// extracted by mini-css-extract-plugin
module.exports = {"image":"LoadingScreen_image__15E-c","content":"LoadingScreen_content__3Gjbb","text":"LoadingScreen_text__8eRqg","spinner":"LoadingScreen_spinner__1feks"};